import React, { useState } from "react";
import NumberFormat from "react-number-format";
import AppBar from "@material-ui/core/AppBar";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import ButtonBase from "@material-ui/core/ButtonBase";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import InputAdornment from "@material-ui/core/InputAdornment";
import Link from "@material-ui/core/Link";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import TextField from "@material-ui/core/TextField";
import Collapse from "@material-ui/core/Collapse";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import Skeleton from "@material-ui/lab/Skeleton";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import MailIcon from "@material-ui/icons/Mail";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";
import analytics from "../../analytics";
import { withContext } from "../../context";
import CartDetails from "../../components/CartDetails";
import ProductListGroup from "../../components/ProductListGroup";
import ProductListItem from "../../components/ProductListItem";
import ImageLoader from "../../components/ImageLoader";
import PoweredBy from "../../components/PoweredBy";
import PaymentWizard from "../../components/PaymentWizard";
import ProductDetails from "../../components/ProductDetails";

const Home = ({
  store,
  mobile,
  data,
  openPayment,
  onOpenPayment,
  onUpdateItems,
  onPaymentCompleted
}) => {
  const [openCart, setOpenCart] = useState(false);
  const [openProduct, setOpenProduct] = useState(false);
  const [selectedProduct, setSelectProduct] = useState(null);

  const [showSearch, setShowSearch] = useState(false);
  const [onView, setOnView] = useState({ categoryOnView: 0, scrollTo: 0 });
  const [searchProducts, setSearchProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const selectProduct = product => {
    if (product) {
      analytics.products([product.id], analytics.metrics.products.vista);
    }

    setSelectProduct(product);
    setOpenProduct(true);
  };

  const sendWhatsapp = message => {
    const url = "https://wa.me/" + store.body.config.whatsapp + "?text=" + message;
    window.open(url, "_blank");
  };

  const toggleSearchbox = () => {
    if (!showSearch) {
      setSearchText("");
    }
    setShowSearch(s => !s);
  };

  const showCart = () => {
    setOpenCart(true);
  };

  const startPaymentWizard = () => {
    onOpenPayment(true);
  };

  const setTab = (tabIndex, scrollIndex) => {
    setOnView({ categoryOnView: tabIndex, scrollTo: scrollIndex });
  };

  const search = async ({ target }) => {
    setSearchText(target.value.toLowerCase());
    const searchText = target.value.toLowerCase();

    if (searchText.length > 2) {
      setLoading(true);

      const filteredProducts = data.products.filter(p => p.name.toLowerCase().includes(searchText));

      setOnView({ categoryOnView: 0, scrollTo: 0 });
      setSearchProducts(filteredProducts);
      setLoading(false);
    } else {
      setOnView({ categoryOnView: 0, scrollTo: 0 });
      setSearchProducts([]);
      setLoading(false);
    }
  };

  const renderLoading = () => {
    const loadingItems = [];

    for (let i = 0; i < 4; i++) {
      loadingItems.push(
        <Grid key={`loading-${i}`} item xs={12} md={6}>
          <Card className="d-flex mb-2">
            <CardContent className="details w-50">
              <div className="text-details">
                <Skeleton variant="text" animation="wave" />

                <Skeleton variant="text" className="mt-3" animation="wave" />
                <Skeleton variant="text" animation="wave" />
                <Skeleton variant="text" animation="wave" />
                <Skeleton variant="text" animation="wave" />
              </div>

              <Skeleton variant="text" width={100} className="mt-4" animation="wave" />
            </CardContent>
            <CardMedia className="media w-50">
              <Skeleton variant="rect" animation="wave" height={200} />
            </CardMedia>
          </Card>
        </Grid>
      );
    }

    return (
      <div className="product-group mb-4">
        <Typography className="mb-3" variant="h6">
          Buscando tus productos...
        </Typography>
        <Grid container spacing={2}>
          {loadingItems}
        </Grid>
      </div>
    );
  };

  const searchList = () => {
    return (
      <div className="product-group mb-4">
        <Typography className="mb-3" variant="h6">
          {"Resultados (" + (searchProducts ? searchProducts.length : 0) + ")"}
        </Typography>
        <Grid container spacing={2}>
          {searchProducts &&
            searchProducts.map((product, i) => {
              let quantity = 0;

              data.items.forEach(item => {
                if (item.productID === product.id) {
                  quantity += item.quantity;
                }
              });

              return (
                <Grid key={`product-group-${i}`} item xs={12} md={6}>
                  <ProductListItem
                    key={`product-${i}`}
                    product={product}
                    quantity={quantity}
                    onSelected={selectProduct}
                  />
                </Grid>
              );
            })}
        </Grid>
      </div>
    );
  };

  const productList = () => {
    return (
      <>
        {data.grouped.map((category, index) => (
          <ProductListGroup
            key={`group-${category.value}`}
            showTitle={data.grouped.length > 1}
            index={index}
            items={data.items}
            group={category}
            executeScroll={onView.scrollTo === index}
            onView={index => setTab(index, null)}
            onSelected={selectProduct}
            onProductChange={onUpdateItems}
          />
        ))}
      </>
    );
  };

  return (
    <>
      <Hidden mdUp>
        <AppBar color="default" className="app-top-bar">
          <Toolbar>
            {store.logo ? (
              <ImageLoader imgKey={store.logo.key} className="logo" circularProgressSize={20} />
            ) : (
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/avatar.png`}
                className="logo"
                alt="Logo"
              />
            )}
            <Typography variant="h6" className="title">
              {store.name}
            </Typography>
            {store.body.config && store.body.config.whatsapp && (
              <IconButton
                aria-label="Conversar con ejecutivo"
                onClick={() => sendWhatsapp("Hola, quiero consultar sobre los productos")}
              >
                <WhatsAppIcon />
              </IconButton>
            )}
          </Toolbar>
        </AppBar>

        {data.products.length > 1 ? (
          <AppBar position="sticky" color="default" elevation={2} className="app-searchbar">
            <Toolbar disableGutters>
              <IconButton color="inherit" onClick={toggleSearchbox}>
                <SearchIcon />
              </IconButton>

              {showSearch ? (
                <TextField
                  fullWidth
                  autoFocus
                  className="search-input"
                  variant="outlined"
                  color="secondary"
                  size="small"
                  placeholder="Ingresa al menos 3 letras"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          onClick={() => {
                            setSearchProducts(null);
                            setShowSearch(false);
                            setLoading(false);
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={search}
                />
              ) : (
                data.grouped.length > 1 && (
                  <Tabs
                    variant="scrollable"
                    scrollButtons="on"
                    value={onView.categoryOnView}
                    onChange={(_, value) => setTab(value, value)}
                  >
                    {data.grouped.map(c => (
                      <Tab key={`tab-category-${c.value}`} label={c.label} />
                    ))}
                  </Tabs>
                )
              )}
            </Toolbar>
          </AppBar>
        ) : (
          <div style={{ height: "60px" }}></div>
        )}
      </Hidden>

      <Hidden smDown>
        <AppBar color="default" className="app-top-bar">
          <Grid container wrap="nowrap" spacing={2} justify="space-between">
            <Grid item md={4} lg="auto">
              <Toolbar>
                {store.logo ? (
                  <ImageLoader imgKey={store.logo.key} className="logo" circularProgressSize={20} />
                ) : (
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/avatar.png`}
                    className="logo"
                    alt="Logo"
                  />
                )}
                <Typography variant="h6" className="title">
                  {store.name}
                </Typography>
              </Toolbar>
            </Grid>

            {data.grouped.length > 1 && (
              <Grid item md={!showSearch ? 6 : 4} lg="auto">
                <Tabs
                  className="mt-2"
                  variant="scrollable"
                  scrollButtons="on"
                  value={onView.categoryOnView}
                  onChange={(_, value) => setTab(value, value)}
                >
                  {data.grouped.map(c => (
                    <Tab key={`tab-category-${c.value}`} label={c.label} />
                  ))}
                </Tabs>
              </Grid>
            )}

            {data.products.length > 1 && (
              <Grid item md={!showSearch ? 2 : 4} lg="auto">
                <Toolbar>
                  <Collapse in={showSearch}>
                    <TextField
                      fullWidth
                      autoFocus
                      className="search-input"
                      variant="outlined"
                      color="secondary"
                      size="small"
                      placeholder="Ingresa al menos 3 letras"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                setSearchProducts(null);
                                setShowSearch(false);
                                setLoading(false);
                              }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      value={searchText}
                      onChange={search}
                    />
                  </Collapse>

                  <IconButton color="inherit" onClick={toggleSearchbox}>
                    <SearchIcon />
                  </IconButton>

                  {store.body.config && store.body.config.whatsapp && (
                    <IconButton
                      className="ml-3"
                      aria-label="Conversar con ejecutivo"
                      onClick={() => sendWhatsapp("Hola, quiero consultar sobre los productos")}
                    >
                      <WhatsAppIcon />
                    </IconButton>
                  )}
                </Toolbar>
              </Grid>
            )}
          </Grid>
        </AppBar>
      </Hidden>

      <PaymentWizard
        mobile={mobile}
        items={data.items}
        total={data.totalPrice}
        open={openPayment}
        onClose={() => onOpenPayment(false)}
        onCompleted={onPaymentCompleted}
      />

      <ProductDetails
        store={store}
        items={data.items}
        totalItems={data.totalItems}
        totalPrice={data.totalPrice}
        product={selectedProduct}
        cartOpen={openCart}
        open={openProduct}
        onClose={() => setOpenProduct(false)}
        onChange={onUpdateItems}
        onWhatsapp={sendWhatsapp}
      />

      <Container maxWidth="lg" className={`${mobile ? "mt-2" : "mt-6"}`}>
        <Grid component="main" container spacing={4}>
          <Grid
            item
            xs={12}
            md={data.items.length > 0 ? 7 : 12}
            lg={data.items.length > 0 ? 8 : 12}
          >
            {loading
              ? renderLoading()
              : showSearch && searchProducts && searchText.length > 2
              ? searchList()
              : productList()}
          </Grid>

          {data.items.length > 0 && (
            <Grid item md={5} lg={4}>
              <CartDetails
                items={data.items}
                total={data.totalPrice}
                open={openCart}
                onClose={() => setOpenCart(false)}
                onDeleteItem={(item, index) => onUpdateItems("delete", item, index)}
                startPaymentWizard={startPaymentWizard}
              />
            </Grid>
          )}
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} className="text-right">
            {store.body.config.phone && (
              <Link
                href={`https://api.whatsapp.com/send?phone=569${store.body.config.phone}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <WhatsAppIcon fontSize="large" color="action" />
              </Link>
            )}
            {store.body.config.email && (
              <Link
                href={`mailto:${store.body.config.email}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <MailIcon fontSize="large" color="action" />
              </Link>
            )}
          </Grid>

          <Grid item xs={12}>
            <Divider light />
          </Grid>

          {store.body.policies && (
            <>
              <Grid item xs={12}>
                <Typography color="textPrimary" variant="body1" className="mx-3 my-2">
                  Políticas
                </Typography>
                {store.body.policies && store.body.policies.cambios && (
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography variant="body1">Cambios</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        className="p-pre"
                        color="textSecondary"
                        variant="body2"
                        component="pre"
                      >
                        {store.body.policies.cambios}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                )}
                {store.body.policies && store.body.policies.devoluciones && (
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography variant="body1">Devoluciones</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        className="p-pre"
                        color="textSecondary"
                        variant="body2"
                        component="pre"
                      >
                        {store.body.policies.devoluciones}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                )}
              </Grid>
            </>
          )}
        </Grid>

        <PoweredBy
          withBottom={data.grouped.length > 0 || (searchProducts && searchProducts.lenght > 0)}
        />
      </Container>

      <Hidden mdUp>
        {data.items.length > 0 && (
          <AppBar color="default" className={`app-bottom-bar ${openPayment && "go-back"}`}>
            <Toolbar className="toolbar-home">
              <ButtonBase disabled={data.totalItems < 1} onClick={showCart}>
                <div className="toolbar-left">
                  <ShoppingCartOutlinedIcon fontSize="large" className="mr-2" />
                  <Typography variant="h6">{data.totalItems}</Typography>
                </div>
                <Typography className="toolbar-right" variant="h6">
                  <NumberFormat
                    value={data.totalPrice}
                    thousandSeparator="."
                    decimalSeparator=","
                    prefix="$"
                    displayType={"text"}
                  />
                </Typography>
              </ButtonBase>
            </Toolbar>
          </AppBar>
        )}
      </Hidden>
    </>
  );
};

export default withContext(Home);
